import { Outlet } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import SmoothScroll from "@/components/SmoothScroll";

export default function Layout() {
  return (
    <SmoothScroll>
      <Header />
      <main className="min-h-screen">
        <Outlet />
      </main>
      <Footer />
    </SmoothScroll>
  );
}
